import { Injectable } from '@angular/core';
import { OCPPService } from './ocpp.service';
import { HttpClient } from '@angular/common/http';
import { ReserveNowRequest } from '../models/ReserveNowRequest';
import { CancelReservationRequest } from '../models/CancelReservationRequest';

@Injectable()
export class ReservationService extends OCPPService {

    private RESERVE_NOW_ENDPOINT = '/reserve-now';
    private CANCEL_RESERVATION_ENDPOINT = '/cancel-reservation';

    getProfileBasePath(): string {
        return '/operations/reservations';
    }

    constructor(private http: HttpClient) {
        super();
    }

    public reserveNow(data: ReserveNowRequest): any {
        return this.http.post(this.BASE_PATH + this.getProfileBasePath() + this.RESERVE_NOW_ENDPOINT, data);
    }

    public cancelReservation(data: CancelReservationRequest): any {
        return this.http.post(this.BASE_PATH + this.getProfileBasePath() + this.CANCEL_RESERVATION_ENDPOINT, data);
    }
}
